import type { ReactNode } from 'react'

import { brand, fonts } from '../brand'

/**
 * Eyebrow no estilo Codout (codout.com): rótulo em JetBrains Mono, uppercase, com um traço ciano
 * à frente. Sobre claro usa slate; sobre escuro usa o ciano claro. Centraliza a assinatura para
 * manter todas as seções coerentes com a marca-mãe.
 */
export function Eyebrow({
  children,
  tone = 'light',
}: {
  children: ReactNode
  tone?: 'light' | 'dark'
}) {
  const isDark = tone === 'dark'
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        fontFamily: fonts.mono,
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: isDark ? brand.signalLight : brand.slate,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 16,
          height: 1.5,
          background: isDark ? brand.signalLight : brand.signalDeep,
        }}
      />
      {children}
    </span>
  )
}
